import { routes } from '@/app/routing/router'
import { DoubleConnectionErrorView } from './view'

const currentRoute = routes.doubleConnection

const DoubleConnectionErrorPageRoute = {
  view: DoubleConnectionErrorView,
  route: currentRoute,
}

export { currentRoute, DoubleConnectionErrorPageRoute }
